var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6v2h5V6a2.5 2.5 0 1 0-5 0M6 8V6a4 4 0 1 1 8 0v2h1c1.103 0 2 .897 2 2v6c0 1.104-.897 2-2 2H5c-1.103 0-2-.896-2-2v-6c0-1.103.897-2 2-2zm-1.5 2v6c0 .275.225.5.5.5h10c.275 0 .5-.225.5-.5v-6c0-.275-.225-.5-.5-.5H5c-.275 0-.5.225-.5.5"
  })));
};
export default SvgLock;